require("./brokerConvenienceTestRadioQuestion.scss");

// @vendors
const React = require("react");
const PropTypes = require("prop-types");

// @components
const { RadioButton } = require("commonsComponents/radioButton");
const { RadioButtonGroup } = require("commonsComponents/radioButtonGroup");
const BrokerConvenienceTestYellowDisclaimer = require("ok-mifid/components/brokerConvenienceTest/brokerConvenienceTestYellowDisclaimer/brokerConvenienceTestYellowDisclaimer");

class BrokerConvenienceTestRadioQuestion extends React.Component {
    constructor(props) {
        super(props);
        this.onSelectRadioButton = this.onSelectRadioButton.bind(this);
    }

    onSelectRadioButton(newValue) {
        const { onChange, questionId, sectionId } = this.props;
        onChange(sectionId, questionId, newValue);
    }
    render() {
        const selectedAnswer = this.props.answer.find((answer) => answer.get('selected') === 'S')
        const selectedId = !!selectedAnswer && selectedAnswer.get('id')
        const disclaimer = this.props.disclaimer ? (
            <BrokerConvenienceTestYellowDisclaimer className="radio-buttons__disclaimer">
                {this.props.disclaimer}
            </BrokerConvenienceTestYellowDisclaimer>
        ) : null;

        const secondDisclaimer = this.props.secondDisclaimer ? (
            <BrokerConvenienceTestYellowDisclaimer className="radio-buttons__disclaimer2">
                {this.props.secondDisclaimer}
            </BrokerConvenienceTestYellowDisclaimer>
        ) : null;
        return (
            <div>
                {disclaimer}
                <div className="radio-buttons__title">
                    {this.props.question}
                </div>
                {secondDisclaimer}
                <div className="radio-buttons__buttons-container">
                    <RadioButtonGroup
                        className={"radio-buttons__group"}
                        name={this.props.questionId}
                        idPrefix={this.props.questionId}
                        selectedValue={selectedId}
                        onChange={this.onSelectRadioButton}
                    >
                        {this.props.answer &&
                            this.props.answer.map((answer, key) => {
                                return (
                                    <RadioButton
                                        key={key}
                                        disabled={false}
                                        label={
                                            <div className="radio-buttons__label-container">
                                                <div className="radio-buttons__label-description">
                                                    {answer.get("description")}
                                                </div>
                                            </div>
                                        }
                                        value={answer.get("id")}
                                    />
                                );
                            })}
                    </RadioButtonGroup>
                </div>
            </div>
        );
    }
}

BrokerConvenienceTestRadioQuestion.propTypes = {
    onChange: PropTypes.func,
    setQuestionShowingId: PropTypes.func,
    answer: PropTypes.object,
    sectionId: PropTypes.number,
    questionId: PropTypes.number,
    question: PropTypes.string,
    disclaimer: PropTypes.string,
    secondDisclaimer: PropTypes.string,
};

module.exports = BrokerConvenienceTestRadioQuestion;
